export enum ApplicationModule {
    Patients = 'Patients',
    Appointments = 'Appointments',
    Prescriptions = 'Prescriptions',
    ChartNotes = 'ChartNotes',
    Labs = 'Labs',
    Images = 'Radiology',
    Documents = 'Documents',
    Injections = 'Injections',
    Referrals = 'Referrals',
    Messages = 'Messages',
    Billing = 'Billing',
    Inventory = 'Inventory',
    Reports = 'Reports',
    Tasks = 'Tasks',
    InitialPlan = 'InitialPlan',
    Dashboard = 'Dashboard',
}
